<div class="litmus-footer-container" [ngStyle]="{'top': isAccount ? '28px' : '0px'  }">
  <div class="litmus-footer-container-items" [ngStyle]="{'padding-left': isAccount ? '20px' : '10px'}">
    <!-- <img src="assets/images/lw_logo_full.svg" /> -->
    <div class="litmus-footer-contents footer-padding">
      <div class="litmus-footer-content">
        <!-- {{ "npsContent" | translate }} -->
        <img src="assets/images/lw_logo_full.svg" /><span class="build-version">{{appVersion}}</span>
      </div>
      <div class="litmus-footer-links litmus-footer-content-right-div">
        {{ "npsContent" | translate }}
      <!-- <div>{{ "appInfo" | translate }}</div>
      <div class="litmus-footer-app-links">
        <img src="assets/images/iOS.svg" />
        <img src="assets/images/Android.svg" />
      </div> -->
      </div>
    </div>
    <!-- <hr class="border-line"> -->
    <div class="litmus-footer-contents">
      <span class="litmus-footer-content">{{copyrightText}}</span>
      <span class="litmus-footer-links">{{ "timeZone" | translate }}</span>
    </div>
  </div>
</div>  